export default "__VITE_ASSET__B_1aVb6q__"